import React from "react";
import styles from "./massengermodal.module.css";
import { resolveProfileImage } from "../../../hooks/useRightSectionState";

const RightSection = ({
  selectedUser,
  safeGetAsset,
  getAvatarUrl,
  sharedSelectedProfile,
}) => {
  const activeProfile = sharedSelectedProfile;
  const recipient = selectedUser?.otherParticipantData;
  const getImage = (profile) => {
    const avatar = getAvatarUrl
      ? getAvatarUrl(profile) ||
        profile?.images ||
        profile?.profilePic ||
        profile?.imageUrl ||
        profile?.image ||
        profile?.profileImage ||
        profile?.logo ||
        profile?.avatar
      : profile?.profilePic ||
        profile?.imageUrl ||
        profile?.image ||
        profile?.profileImage ||
        profile?.images ||
        profile?.logo ||
        profile?.avatar;
    return safeGetAsset
      ? safeGetAsset(avatar)
      : resolveProfileImage(avatar || profile?.images || profile?.logo);
  };
  const profileName = (profile) =>
    profile?.displayName ||
    profile?.fullname ||
    profile?.name ||
    profile?.shopname ||
    profile?.shopName ||
    "Profile";
  const profileCategory = (profile) =>
    profile?.businessType || profile?.category || profile?.position || "";
  const metaValue = (value) => {
    if (typeof value !== "object" || value === null) return value || "";
    if (Array.isArray(value)) {
      return value.map(metaValue).filter(Boolean).join(", ");
    }
    const directValue =
      value.text ||
      value.name ||
      value.address ||
      value.shopaddress ||
      value.shopAddress ||
      value.formattedAddress ||
      value.fullAddress ||
      value.addressLine ||
      value.addressLine1 ||
      value.description ||
      value.label;
    if (directValue) return metaValue(directValue);

    const locationParts = [
      value.building,
      value.street,
      value.area,
      value.town,
      value.city,
      value.district,
      value.state,
      value.province,
      value.country,
      value.postalCode,
      value.zipCode,
    ]
      .map(metaValue)
      .filter(Boolean);
    if (locationParts.length) return locationParts.join(", ");

    return metaValue(
      value.location ||
        value.addressDetails ||
        value.shopLocation ||
        value.businessLocation
    );
  };
  const profileLocation = (profile) =>
    [
      profile?.shopaddress,
      profile?.shopAddress,
      profile?.address,
      profile?.publicAddress,
      profile?.businessAddress,
      profile?.fullAddress,
      profile?.addressLine,
      profile?.companyaddress,
      profile?.marketPlace,
      profile?.marketplace,
      profile?.MAddress,
      profile?.location,
      profile?.gpsLocation,
      profile?.ipLocation,
      [
        profile?.MCity,
        profile?.MProvince,
        profile?.MCountry,
      ],
      [
        profile?.building,
        profile?.street,
        profile?.area,
        profile?.town,
        profile?.city,
        profile?.district,
        profile?.state,
        profile?.province,
        profile?.country,
        profile?.postalCode,
      ],
      [
        profile?.resolvedCity,
        profile?.resolvedRegion,
        profile?.resolvedCountry,
      ],
    ]
      .map(metaValue)
      .find(Boolean) || "";

  return (
    <div className={styles.rightSection}>
      {activeProfile && (
        <>
          <h6 className={styles.sideSectionTitle}>From</h6>
          <div className={styles.userInfo}>
            <img
              src={getImage(activeProfile)}
              alt={profileName(activeProfile)}
              crossOrigin="anonymous"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = require("../../../assets/images/dummy/user-avatar-img.jpg");
              }}
            />
            <div>
              <h6>{profileName(activeProfile)}</h6>
            </div>
          </div>
          <div className={styles.profileMeta}>
            <p className={styles.profileMetaLabel}>Category</p>
            <p className={styles.profileMetaValue}>{metaValue(profileCategory(activeProfile))}</p>
          </div>
          <div className={styles.profileMeta}>
            <p className={styles.profileMetaLabel}>Location</p>
            <p className={styles.profileMetaValue}>{metaValue(profileLocation(activeProfile))}</p>
          </div>
        </>
      )}
      {recipient && (
        <>
          <h6 className={styles.sideSectionTitle}>To</h6>
          <div className={styles.userInfo}>
            <img
              src={getImage(recipient)}
              alt={profileName(recipient)}
              crossOrigin="anonymous"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = require("../../../assets/images/dummy/user-avatar-img.jpg");
              }}
            />
            <h6>{profileName(recipient)}</h6>
          </div>
          <div className={styles.profileMeta}>
            <p className={styles.profileMetaLabel}>Category</p>
            <p className={styles.profileMetaValue}>{metaValue(profileCategory(recipient))}</p>
          </div>
          <div className={styles.profileMeta}>
            <p className={styles.profileMetaLabel}>Location</p>
            <p className={styles.profileMetaValue}>{metaValue(profileLocation(recipient))}</p>
          </div>
        </>
      )}
    </div>
  );
};

export { RightSection };
export default RightSection;
